// Custom close button: delegate to the drawer's own toggle so aria-expanded,
// scroll lock and focus handling stay in sync. Delegated + guarded so it
// survives header re-renders in the theme editor without double-binding.
document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('.menu-drawer_close-button');
    if (!closeButton) return;
    const details = closeButton.closest('header-drawer')?.querySelector('#Details-menu-drawer-container');
    if (details?.hasAttribute('open')) details.querySelector(':scope > summary').click();
});


// Open dropdowns on mouse hover (desktop only). Touch and keyboard keep the
// theme's default click/Enter behavior. Delegated + guarded so it survives
// header re-renders in the theme editor without double-binding.
const MENU_DETAILS = '.header__inline-menu details';
const CLOSE_DELAY = 200; // ms grace period for crossing gaps between a link and its dropdown
const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
const closeTimers = new Map();
let lastPointerType = 'mouse';

const setOpen = (details, open) => {
    clearTimeout(closeTimers.get(details));
    closeTimers.delete(details);
    if (details.open === open) return;
    details.open = open;
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', open);
    if (!open) details.querySelectorAll('details[open]').forEach((child) => setOpen(child, false));
};

const scheduleClose = (details) => {
    if (closeTimers.has(details)) return;
    closeTimers.set(details, setTimeout(() => setOpen(details, false), CLOSE_DELAY));
};

const onHover = (target) => {
    const hovered = new Set();
    for (let d = target?.closest?.(MENU_DETAILS); d; d = d.parentElement.closest(MENU_DETAILS)) hovered.add(d);

    document.querySelectorAll(MENU_DETAILS).forEach((details) => {
    if (hovered.has(details)) {
        setOpen(details, true);
    } else if (details.open) {
        // Switching between top-level menus closes the previous one immediately.
        const switchingTopLevel =
        details.parentElement.matches('header-menu') &&
        [...hovered].some((d) => d.parentElement.matches('header-menu'));
        switchingTopLevel ? setOpen(details, false) : scheduleClose(details);
    }
    });
};

document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse' || !canHover.matches) return;
    onHover(event.target);
});

document.addEventListener('pointerout', (event) => {
    // Pointer left the browser window.
    if (event.pointerType === 'mouse' && canHover.matches && !event.relatedTarget) onHover(null);
});

document.addEventListener('pointerdown', (event) => (lastPointerType = event.pointerType), true);

// A mouse click on a summary that hover already opened shouldn't toggle it shut.
// Capture phase so the theme's aria-expanded click handler doesn't fire either.
document.addEventListener(
    'click',
    (event) => {
    const summary = event.target.closest(`${MENU_DETAILS} > summary`);
    if (!summary || !summary.parentElement.open) return;
    if (!canHover.matches || event.detail === 0 || lastPointerType !== 'mouse') return;
    event.preventDefault();
    event.stopPropagation();
    },
    true
);

// Mobile drawer: open submenus in place (accordion) instead of the theme's
// slide-over panel. Capture phase + stopPropagation keeps the theme's
// MenuDrawer handler (panel, focus trap) from running; the browser's native
// <details> toggle does the opening and closing.
const DRAWER_DETAILS = '.menu-drawer__navigation details';

document.addEventListener(
    'click',
    (event) => {
    if (event.target.closest(`${DRAWER_DETAILS} > summary`)) event.stopPropagation();
    },
    true
);

// Keep aria-expanded in sync however a submenu opens or closes (tap, keyboard,
// or the theme collapsing everything when the drawer closes). 'toggle' doesn't
// bubble, so listen during capture.
document.addEventListener(
    'toggle',
    (event) => {
    if (!event.target.matches?.(DRAWER_DETAILS)) return;
    event.target.querySelector(':scope > summary')?.setAttribute('aria-expanded', event.target.open);
    },
    true
);
